import React, {useState, useEffect, useContext, memo} from "react";
import  {UserContext} from "../../providers/UserProvider";

import { Button,  Form} from "react-bootstrap";
import ImageFadeIn from "react-image-fade-in";

import Select, { createFilter } from "react-select";

import BigText from './helpers/BigText';
import LoadingPage from "./helpers/LoadingPage";

import cross from './helpers/cross.png';
import question from './helpers/questionOrange.png';

import { Box, getBorderColor, keyListener, ShowTree } from "./helpers/blocks";

import './helpers/blocks.css';
import '../css/Components.css';
import '../css/Syntax.css';

const LQV_Syntax =({curQ, curQ2, curPi, setPartInst, setAnsSaved, btnClicked, allVerseQuestions}) =>{
	// curQ.text.boxes is a list. 0th element is the qDeva and the rest of them are boxes
	const {currentUser} = useContext(UserContext);
	
	console.log("## Syntax ##", curQ, curQ2);

	// const [qText, setQText] =useState('');
	// const [qText2, setQText2] =useState('');
	// if ('boxes' in curQ.text){
	// 	setQText(String(curQ.text.boxes[0]));
	// }
	// if ('boxes' in curQ2.text){
	// 	setQText2(String(curQ2.text.boxes[0]));
	// }
	// Use allVerseQuestions if provided, otherwise fallback to curQ/curQ2
	const [questions, setQuestions] = useState([]);
	const [qTexts, setQTexts] = useState([]);
	const [showText, setShowText] = useState('loading...');
	const [ansState, setAnsState] = useState("NOT_SET");
	const [loading, setLoading] = useState(false);
	const [completed, setCompleted] = useState('');

	useEffect(() => {
		// Use allVerseQuestions if provided, otherwise fallback to curQ/curQ2
		const allQuestions = (allVerseQuestions && allVerseQuestions.length > 0) 
			? allVerseQuestions 
			: [curQ, curQ2].filter(q => q && Object.keys(q).length > 0);
		setQuestions(allQuestions);
		
		if (allQuestions.length > 0) {
			const firstQ = allQuestions[0];
			if (firstQ.text && firstQ.text.allComplete)
				setCompleted('all');
			else if (firstQ.text && firstQ.text.primaryComplete)
				setCompleted('primary');
			else
				setCompleted('');

			if (allQuestions.every(q => q.takeInput)) {
				setAnsState(firstQ.uans || "NOT_SET");
				setQTexts(allQuestions.map(q => q.text && q.text.boxes ? String(q.text.boxes[0]) : ''));
			}
		}
	}, [curQ, curQ2, allVerseQuestions]);

	useEffect(()=>{
		setShowText(qTexts.join("<br>"));
	}, [qTexts]);

	// Helper Functions
	const getPlaceholder =(index, key, defaultVal, curQ)=>{
		if (!curQ || !curQ.text || !ansState || !ansState[index]) return '';
		
		if (key ==="relation" && ansState[index][key] && curQ.text.primaryOptions && curQ.text.primaryOptions[index]){
			let robj = curQ.text.primaryOptions[index].find(o=>o.value ===ansState[index][key]);
			return robj ? robj.deva : '';
		}
		if (key ==="secondaryRelation" && ansState[index][key] && curQ.text.secondaryOptions && curQ.text.secondaryOptions[index]){
			let robj = curQ.text.secondaryOptions[index].find(o=>o.value ===ansState[index][key]);
			return robj ? robj.deva : '';
		}

		else if (key==="parent" && ansState[index]['parentVal'] && ansState[index]['parentVal'].length >0){
			return ansState[index]['parentVal'].join(', ');
		}
		else if (key==="targets" && ansState[index]['targetsVal'] && ansState[index]['targetsVal'].length >0){
			return ansState[index]['targetsVal'].join(', ');
		}
		else
			return '';
	};
	const formatRelationLabel =(data, meta)=>{
		if(meta.context === 'menu'){
			return (
				<div className="d-flex flex-column flex-nowrap lessMargins">
					<div className="mainLabel">
						{data.deva}
					</div>
					<div className="subLabel">
						{data.english}
					</div>
				</div>
			);
		}
		if(meta.context ==='value'){
			return(
				<div className="mainLabel lessMargins">
					{data.deva}
				</div>
			);
		}
	};
	const formatParentLabel =(data, meta)=>{
		if (meta.context ==='value'){
			return (
				<div className="mainLabel lessMargins">
					{data.label}
				</div>
			)
		}
		if (meta.context ==='menu'){
			if (data.parentIdx ===0 || data.parentIdx > 100){
				return (
					<div className="d-flex flex-column flex-nowrap lessMargins">
						<div className="mainLabel">
							{data.label}
						</div>
						<div className="subLabel">
							{data.value}
						</div>
					</div>
				)
			}
			else{
				return(
					<div className="mainLabel lessMargins">
						{data.label}
					</div>
				)
			}
		}
	};

	// Handle change
	const handleSelectChange = (index, name, selected) => {
		let values = {...ansState};
		
		if (selected===null)
			selected ={value:''};
		
		// console.log('selected', selected);
		// console.log('values', values[index]);
		switch(name){
			case "relation":
				values[index]['relation'] = selected.value;
				if (selected.value ==='praDAnakriyA'){
					values[index]['disableParent'] = true;
					values[index]['parentIdx'] =[];
					values[index]['parentVal'] =[];
				}
				else{
					values[index]['disableParent'] = false;
				}
				break;
			case "parent":
				values[index]['parentVal'] =[];
				values[index]['parentIdx'] =[];
				selected.map(cur =>{
					values[index]['parentVal'].push(cur.label);
					values[index]['parentIdx'].push(cur.parentIdx);
					return null;
				});
				break;

			case "secondaryRelation":
				values[index]['secondaryRelation'] = selected.value;
				break;
			case "targets":
				values[index]['targetsVal'] =[];
				values[index]['targetsIdx'] =[];
				selected.map(cur =>{
					values[index]['targetsVal'].push(cur.label);
					values[index]['targetsIdx'].push(cur.parentIdx);
					return null;
				});
				break;

			default:
				break;
		}
		
		setAnsState(values);
	};

	//Check User's Answer
	// Checking the user's answers

	//checking box or all depending on checkType
	const check =(checkType, boxIndex, questionIndex=0) =>{	
		// console.log("checking:"+checkType +" | boxIndex="+boxIndex +" | questionIndex="+questionIndex);
		// console.log('AnsStates', ansState);
		const postObj = {
			method: 'POST',
			cache: 'no-cache',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({ uans: ansState, curPart: 'syntax',
											pi: curPi, email: currentUser.email, checkType: checkType,
											questionIndex: questionIndex, boxIndex: boxIndex,
											curQs: questions })
		};
	
		const getFeedback =async () => {
			setLoading(true);

			try {
				const response = await fetch(process.env.REACT_APP_FLASK_API+'check_lqv_uans', postObj);
				const data = await response.json();
				console.log("##G O T data:", data);

				if (data.error) {
					console.error("Backend error:", data.error);
					setPartInst(data.error);
					setLoading(false);
					return;
				}

				if (!data.analysis) {
					console.error("No analysis in response:", data);
					setPartInst("Error: Invalid response from server");
					setLoading(false);
					return;
				}

				if (checkType === 'All') {
					// Update all questions
					setAnsState(data.analysis.afterState);
					if (data.analysis.allComplete)
						setCompleted('all');
					else if(data.analysis.primaryComplete)
						setCompleted('primary');
					else
						setCompleted('');
				} else if (checkType === 'Box') {
					// Update specific box
					setAnsState(data.analysis.afterState);
					if (data.analysis.allComplete)
						setCompleted('all');
					else if(data.analysis.primaryComplete)
						setCompleted('primary');
					else
						setCompleted('');
				}

				setPartInst(data.instruction);
			} catch (error) {
				console.error("Error in syntax validation:", error);
				setPartInst("Error: " + error.message);
			}

			setLoading(false);
		};
		getFeedback();
	};

	//Enter = Submit
	const [btn, setBtn]=useState(null)
	useEffect(() => {
		if (btn){
			// create an eventListener
			window.addEventListener('keydown', e=>keyListener(e, btn));
		}
	}, [btn]);
	useEffect(()=>{
		console.log('mounting syntax');
		return () => {
			// Cleanup
			console.log('unmounting syntax');
			window.removeEventListener('keydown', e=>keyListener(e, btn));
		};
	}, []);

	// To autosave when next or previous buttons are clicked
	useEffect(()=>{
		if (btnClicked===true){
			check('All', 0, 0);
			setAnsSaved(true);
		};
	}, [btnClicked, check, setAnsSaved]);

	// Select styles object
	const selectStyles ={
		placeholder: defaultStyles=>{
			return {
				...defaultStyles,
				fontSize: '20pt',
				fontFamily: 'Shobhika',

				marginTop: '3px'
			}
		}
	};

	// Calculate tree xmlid
	const OneBox=({cur, boxIndex, curQ, questionIndex})=>{
		// Calculate answer index based on offsets from all questions
		let ansIdx = boxIndex + 1;
		let offset = 0;
		for (let i = 0; i < questionIndex; i++) {
			if (questions[i] && questions[i].text && questions[i].text.boxes) {
				offset += questions[i].text.boxes.length - 1; // minus 1 for the question text
			}
		}
		ansIdx = boxIndex + offset + 1;
		
		console.log(cur, boxIndex, ansIdx, ansState)
		let uans = ansState && ansState[ansIdx] ? ansState[ansIdx] : {};
		let borderColor = getBorderColor((uans.relationError || uans.parentError || uans.secondaryError || uans.targetsError), uans.allCorrect);

		return (
			<Box key={`${cur.title}${boxIndex}`} borderColor={borderColor}>
				<div style={{'textAlign':'center'}}>
					<div style={{fontFamily:'Shobhika', fontSize:'20pt'}}>
						{cur.title}
					</div>
					<div className='line'/>
					
					{[cur.inflection, cur.pos].map((value, i)=>{
						if (value.length)
							return (<div key={i}>{value}</div>);
						else
							return (<br key={i}/>);
					})}
					{cur.addRoot===true &&
						<div>{cur.root}, {cur.rootPos}</div>
					}
					{/* <div className="text-center" style={{wordWrap:'break-word'}}>{cur.trans}</div> */}
					{/* <Form.Control as="textarea" readonly className="text-center"  value={cur.trans} /> */}
					<Form.Control type="text" readOnly className="text-center"  value={cur.trans} />
					{/* <Form.Control type="textarea" readOnly className="text-center"  value={cur.trans} /> */}
				</div>

				{curQ.text.validIdx.includes(boxIndex+1) &&
					<>
					{ansState[ansIdx]['primary'] && 
						<div className="inputGroup">
							<div style={{minWidth:'100%'}}>
								<label htmlFor={`"relation"${ansIdx}`} 
										className="boxLabel smText">
								Syntactic role
								{ansState[ansIdx]['relationError']===true&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={cross} alt='wrong'/>
								}
								{ansState[ansIdx]['relationError']==='?'&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={question} alt='empty'/>
								}
								</label>
								<Select
									isClearable
									backspaceRemovesValue
									
									name ="relation"
									id ={`"relation"${ansIdx}`}
									aria-describedby ={`"relationError"${ansIdx}`}
									
									styles ={selectStyles}
									options ={curQ.text.primaryOptions[ansIdx]}
									maxMenuHeight ={200}

									filterOption ={createFilter({ignoreCase:false, ignoreAccents:false, trim:true,  matchFrom:'start'})}
									formatOptionLabel ={formatRelationLabel}

									placeholder ={getPlaceholder(ansIdx, "relation", "Syntactic role", curQ)}
									onChange ={(selectedOption) => handleSelectChange(ansIdx, "relation", selectedOption)}
								/>
								
							</div>
							
							{!ansState[ansIdx]['disableParent'] &&
							<div style={{minWidth:'100%'}}>
								<label htmlFor={`"parent"${ansIdx}`} 
										className="boxLabel smText">
								Parent
								{ansState[ansIdx]['parentError']===true&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={cross} alt='wrong'/>
								}
								{ansState[ansIdx]['parentError']==='?'&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={question} alt='empty'/>
								}
								</label>
								<Select
									isMulti
									isClearable
									backspaceRemovesValue

									isDisabled ={ansState[ansIdx]['disableParent']}
									
									name="parent"
									id={`"parent"${ansIdx}`}
									aria-describedby={`"parentError"${ansIdx}`}
									
									styles ={selectStyles}
									options={curQ.text.parents}
									maxMenuHeight={200}

									filterOption={createFilter({ignoreCase:false, ignoreAccents:false, trim:true,  matchFrom:'start'})}
									formatOptionLabel ={formatParentLabel}

									placeholder={getPlaceholder(ansIdx, "parent", "Parent", curQ)}
									onChange={(selectedOption) => handleSelectChange(ansIdx, "parent", selectedOption)}
								/>
								
							</div>
							}
						</div>
					}
					{ansState[ansIdx]['secondary'] && 
						<div className="inputGroup">
							<div style={{minWidth:'100%'}}>
								<label htmlFor={`"secondaryRelation"${ansIdx}`} 
										className="boxLabel smText">
								Secondary role
								{ansState[ansIdx]['secondaryError']===true&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={cross} alt='wrong'/>
								}
								{ansState[ansIdx]['secondaryError']==='?'&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={question} alt='empty'/>
								}
								</label>
								<Select
									isClearable
									backspaceRemovesValue
									
									name ="secondaryRelation"
									id ={`"secondaryRelation"${ansIdx}`}
									aria-describedby ={`"secondaryError"${ansIdx}`}
									
									styles ={selectStyles}
									options ={curQ.text.secondaryOptions[ansIdx]}
									maxMenuHeight ={200}

									filterOption ={createFilter({ignoreCase:false, ignoreAccents:false, trim:true,  matchFrom:'start'})}
									formatOptionLabel ={formatRelationLabel}

									placeholder ={getPlaceholder(ansIdx, "secondaryRelation", "Secondary role", curQ)}
									onChange ={(selectedOption) => handleSelectChange(ansIdx, "secondaryRelation", selectedOption)}
								/>
								
							</div>
							
							<div style={{minWidth:'100%'}}>
								<label htmlFor={`"targets"${ansIdx}`} 
										className="boxLabel smText">
								Targets
								{ansState[ansIdx]['targetsError']===true&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={cross} alt='wrong'/>
								}
								{ansState[ansIdx]['targetsError']==='?'&&
									<ImageFadeIn opacityTransition={3} style={{float:'right'}} 
									width={25} height={25} src={question} alt='empty'/>
								}
								</label>
								<Select
									isMulti
									isClearable
									backspaceRemovesValue

									name="targets"
									id={`"targets"${ansIdx}`}
									aria-describedby={`"targetsError"${ansIdx}`}
									
									styles ={selectStyles}
									options={curQ.text.parents}
									maxMenuHeight={200}

									filterOption={createFilter({ignoreCase:false, ignoreAccents:false, trim:true,  matchFrom:'start'})}
									formatOptionLabel ={formatParentLabel}

									placeholder={getPlaceholder(ansIdx, "targets", "Targets", curQ)}
									onChange={(selectedOption) => handleSelectChange(ansIdx, "targets", selectedOption)}
								/>
								
							</div>
						</div>
					}
					<div style={{minWidth:'100%', display:'flex', justifyContent:'flex-end'}}>
						<Button variant='outline-primary' size='sm' 
							style={{marginTop:'10px'}}
							onClick={e=>check('Box', boxIndex+1, questionIndex)}>Check
						</Button>
					</div>
					</>
				}

			</Box>
		)
	};

	if (ansState!=="NOT_SET" && questions.length > 0){
		const firstQ = questions[0];
		return (
			<div>
				<ShowTree xmlid={firstQ.vxmlid} completed={completed}/>

				<LoadingPage loading={loading} />
				
				{firstQ.takeInput &&
				<>
					<span style={{fontFamily:'Shobhika'}}>
						<BigText sp="Q:" text={showText} colored={true}/> 
					</span>
		
					<div className="FlexBox">
						<BigText sp="A:" />
						<div className="AnsForm">
							<div className="d-flex-column">
								<div className="containerBox">
									{questions.map((q, questionIndex) => (
										q.text && q.text.boxes && q.text.boxes.slice(1).map((cur, boxIndex) => (
											<div key={`${questionIndex}-${boxIndex}`}>
												{OneBox({cur: cur, boxIndex: boxIndex, curQ: q, questionIndex: questionIndex})}
											</div>
										))
									))}
								</div>
							</div>
						
							<div className="KeepRight">
								<Button variant='primary' onClick={e=>check('All', 0, 0)} 
											ref={node=>setBtn(node)}>
									Check all
								</Button>
							</div>
						
						</div>

					</div>
				</>
				}
			</div>
		);
	} else {
		return (<div><LoadingPage loading={true} /></div>)
	}
};

export default LQV_Syntax;